<template>
  <div class="">
    <div
      v-if="totalHeaders.length"
      class="items-container">
      <vuedraggable
        group="moduleCards"
        ghost-class="ghost"
        class="dropzone"
        :list="totalHeaders">
        <div
          v-for="(row, i) in totalHeaders"
          :key="i"
          class="row-item">
          <TrackerTotalHeader
            v-model="totalHeaders[i]"
            @delete="removeRow(i)" />
        </div>
      </vuedraggable>
    </div>
    <button
      class="button add-row-button"
      @click.stop="addRow">
      <img
        src="@/assets/icons/add-row.svg"
        alt="" />

      <div>Add total column</div>
    </button>
  </div>
</template>

<script>
  import TrackerTotalHeader from '@/components/pdf_report/tracker_table_module/TrackerTotalHeader.vue'
  import vuedraggable from 'vuedraggable'
  import uniqid from 'uniqid'
  export default {
    name: 'TrackerTotalHeaders',
    components: {
      TrackerTotalHeader,
      vuedraggable,
    },
    props: {
      value: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {}
    },
    computed: {
      totalHeaders: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },

    mounted () {},

    beforeDestroy () {},
    methods: {
      removeRow (index) {
        this.totalHeaders.splice(index, 1)

        this.$parent.module.tracker_rows.forEach((row) => {
          row.tracker_row_totals.splice(index, 1)
        })
      },
      addRow () {
        this.totalHeaders.push({
          title: '',
          sub_title: '',
        })

        this.$parent.module.tracker_rows.forEach((row) => {
          row.tracker_row_totals.push({
            key: uniqid(),
            type: 'TrackerRowTotal',
            measure_config: null,
            conditional_format: null,
            data_format: null,
          })
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.items-container {
  background-color: #fbfbfb;
  padding: 5px 15px;

  border: $border-1;
  border-radius: 10px;

  height: 100%;
  display: flex;
  flex-direction: column;

  overflow: auto;
}

.add-row-button {
  margin-top: 20px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
  font-size: 15px;
  justify-content: center;
  color: $grayscale-1 !important;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.1) !important;
  background: rgba(0,0,0,0.03) !important;
  justify-content: flex-start;

  img {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }

  &:hover {
    border: 1px solid rgba(0,0,0,0.2)
  }
}
</style>
